export default (key: string): string | undefined => process.env[`REACT_APP_${key}`];

export const conf = (key: string): string | undefined => process.env[`REACT_APP_${key}`];
